import React, { useState, useEffect, useRef } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { HomeSlider } from "./HomeSlider";

const featuredProducts = [
  "/images/main.jpg",
  "/images/constuction.jpg",
  "/images/health.jpg",
  "/images/petrolium.jpg",
  "/images/it.jpg",
  "/images/general.jpg",





];

let count = 0;
let slideInterval;
export default function Slider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const slideRef = useRef();

  const removeAnimation = () => {
    slideRef.current.classList.remove("fade-anim");
  };

  useEffect(() => {
    slideRef.current.addEventListener("animationend", removeAnimation);
  
    startSlider();
    return () => {
      pauseSlider();
    };
   
  }, []);

  const startSlider = () => {
    slideInterval = setInterval(() => {
      handleOnNextClick();
    }, 6000);
  };

  const pauseSlider = () => {
    clearInterval(slideInterval);
  };

  const handleOnNextClick = () => {
    count = (count + 1) % featuredProducts.length;
    setCurrentIndex(count);
    slideRef.current.classList.add("fade-anim");
  };

  useEffect(() => {
    Aos.init({ duration: 600 });
  }, []);

  return (
    <div
      ref={slideRef}
      className="w-full xs:h-[50vh] md:h-full select-none relative Slider"
    >
      <div className="w-full ">
        {/* <img className =" w-full xs:h-[50vh] sm:h-[70vh] md:h-full object-cover" src={featuredProducts[currentIndex]} alt="" /> */}
        {/* <div className="absolute w-full xs:h-[50vh] sm:h-[70vh] md:h-full bg-black top-0 opacity-[80%]"></div> */}
      <HomeSlider/>
      </div>

    
        <div
          className=" absolute xs:top-[56.5%] xs:left-[72%] md:top-[29.5%] md:left-[30%] lg:top-[34%] lg:left-[30%] xl:top-[38%] xl:left-[30%] mr-auto ml-auto right-0   flex flex-col justify-center items-ceneter text-center  "
          data-aos="fade-right"
        >
          <div className="text-center flex flex-col items-center xs:pt-[40px] md:pt-[150px] justify-center">
            {/* <div className="ml-5">
            <img src={Loggo} alt="" className="xs:w-[200px] md:w-[350px]"/>
            </div> */}
            <div
              data-aos="fade-right"
              data-aos-delay="200"
              className="flex flex-col "
            >
              {/* <div>
                <p className="sub-text  md:pb-4">
                  Our mission is to foster sustainable development by recycling <br></br>
                  plastic waste into useable products.
                </p>
              </div> */}
              <div>
                <a
                  href="#contact"
                  className=" "
                >
                    {/* <button className=" intro-btn text-[#ffe100] rounded-sm xs:w-[100px] md:w-[200px] md:p-3 font-[500] underline md:text-[17px]">
                 LEARN MORE
                  </button> */}
                </a>
              </div>
            </div>
          </div>
        </div>
     
      </div>
 
  );
}
